<ul class="navbar-nav d-flex align-items-end align-items-lg-center gap-1 gap-lg-3">
  @for (nav of navigation(); track nav.routing_path + $index) {
    <li class="nav-item" routerLinkActive="active">
      <a
        class="nav-link text-center py-0 pb-2 py-lg-2"
        (click)="closeNavigation.emit(true)"
        [routerLink]="[nav.routing_path]"
      >
        {{ nav.translate | translate }}
      </a>
    </li>
  }
  <li class="nav-item nav-btn">
    <app-notifications />
  </li>
  <li class="nav-item nav-btn py-2">
    <app-login-button />
  </li>
  <li class="nav-item nav-btn">
    <a>
      <select [formControl]="languageControl()" class="rounded-4" style="max-width: 150px">
        @for (language of languages(); track language.id) {
          <option [value]="language.abbreviation">
            {{ language.name }}
          </option>
        }
      </select>
    </a>
  </li>
</ul>
